//* Schemas imports
import type { ISale, ISaleOutputDTO } from "@/schemas/sales";
import type { IFinancialConfig } from "@/schemas/financial";

export const getSalePrice = (
  sale: ISale | ISaleOutputDTO | null | undefined,
): number => {
  return getSaleCashPrice(sale);
};

export const getSaleCashPrice = (
  sale: ISale | ISaleOutputDTO | null | undefined,
): number => {
  if (!sale) return 0;

  //! 1. Verifica se há um preço cash override na configuração financeira da venda
  if (sale.financialConfig?.cashPrice !== undefined) {
    return sale.financialConfig.cashPrice;
  }

  //! 2. Verifica se há um preço cash override na configuração financeira do produto
  if (
    typeof sale.productId === "object" &&
    sale.productId !== null &&
    "financialConfig" in sale.productId &&
    sale.productId.financialConfig?.cashPrice !== undefined
  ) {
    return sale.productId.financialConfig.cashPrice;
  }

  //! 3. Fallback to legacy price field (if exists)
  return (sale as any).price || 0;
};

export const getSaleInstallmentPrice = (
  sale: ISale | ISaleOutputDTO | null | undefined,
): number => {
  if (!sale) return 0;

  //! 1. Verifica se há um preço de parcelamento override na configuração financeira da venda
  if (sale.financialConfig?.installmentPrice !== undefined) {
    return sale.financialConfig.installmentPrice;
  }

  //! 2. Verifica se há um preço de parcelamento override na configuração financeira do produto
  if (
    typeof sale.productId === "object" &&
    sale.productId !== null &&
    "financialConfig" in sale.productId &&
    sale.productId.financialConfig?.installmentPrice !== undefined
  ) {
    return sale.productId.financialConfig.installmentPrice;
  }

  return 0;
};

export const getSaleFinancialConfig = (
  sale: ISale | ISaleOutputDTO | null | undefined,
): IFinancialConfig | undefined => {
  if (!sale) return undefined;

  //! 1. Verifica se há uma configuração financeira override na configuração financeira da venda
  if (sale.financialConfig) {
    const productFinancialConfig =
      typeof sale.productId === "object" &&
      sale.productId !== null &&
      "financialConfig" in sale.productId
        ? sale.productId.financialConfig
        : undefined;

    return {
      ...productFinancialConfig, // Merge with product config as base (if exists)
      ...sale.financialConfig, // Override with sale config
    };
  }

  //! 2. Verifica se há uma configuração financeira na configuração financeira do produto
  if (
    typeof sale.productId === "object" &&
    sale.productId !== null &&
    "financialConfig" in sale.productId
  ) {
    return sale.productId.financialConfig;
  }

  return undefined;
};
